import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from "react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { Grid, makeStyles, InvoicesData, Skeleton, DataTable, Button, Typography } from "../../../";
import _ from "lodash";
import MomentUtils from "@date-io/moment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel"; // import { Button } from "@material-ui/core";

import FilterListIcon from "@material-ui/icons/FilterList";
import moment from "moment";
import { MenuItem, Select } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    flex: {
      display: "flex",
      "justify-content": "flex-start"
    },
    wrap: {
      "flex-wrap": "wrap"
    },
    layout: {
      display: "flex",
      "flex-direction": "column",
      "padding-left": "15px"
    }
  };
});

var FilterInvoicesList = function FilterInvoicesList(_ref) {
  var dashboard = _ref.dashboard,
      invoices = _ref.invoices,
      compareInvoices = _ref.compareInvoices,
      centralView = _ref.centralView,
      franchise = _ref.franchise,
      locale = _ref.locale,
      translation = _ref.translation,
      getFilteredInvoices = _ref.getFilteredInvoices,
      columns = _ref.columns,
      options = _ref.options,
      year = _ref.year,
      groupedByCategory = _ref.groupedByCategory,
      centralUser = _ref.centralUser,
      handleSelectYears = _ref.handleSelectYears,
      totals = _ref.totals,
      billingCentral = _ref.billingCentral,
      props = _objectWithoutProperties(_ref, ["dashboard", "invoices", "compareInvoices", "centralView", "franchise", "locale", "translation", "getFilteredInvoices", "columns", "options", "year", "groupedByCategory", "centralUser", "handleSelectYears", "totals", "billingCentral"]);

  var classes = useStyles(); // console.log("FilterInvoicesList locale", locale);

  var categoriesState = centralUser ? {
    initial_fee: false,
    recurring_fee: false,
    others: false,
    marketing: false,
    office: false,
    marketplace: false
  } : {
    events: false,
    campus: false,
    academies: false,
    others: false
  };
  var statusesState = centralUser ? {
    paid: false,
    pending: false,
    open: false,
    amended: false,
    amending: false,
    uncollectable: false
  } : {
    paid: false,
    pending: false,
    amended: false,
    amending: false
  };

  var _useState = useState(categoriesState),
      _useState2 = _slicedToArray(_useState, 2),
      categories = _useState2[0],
      setCategories = _useState2[1];

  var _useState3 = useState(statusesState),
      _useState4 = _slicedToArray(_useState3, 2),
      statuses = _useState4[0],
      setStatuses = _useState4[1];

  var _useState5 = useState({
    from: null,
    to: null
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      dates = _useState6[0],
      setDates = _useState6[1];

  var _useState7 = useState(_toConsumableArray(invoices)),
      _useState8 = _slicedToArray(_useState7, 2),
      filteredInvoices = _useState8[0],
      setFilteredInvoices = _useState8[1];

  var _useState9 = useState(_objectSpread({}, dashboard)),
      _useState10 = _slicedToArray(_useState9, 2),
      filteredDashboard = _useState10[0],
      setfilteredDashboard = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showFilters = _useState12[0],
      setShowFilters = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      showCompareYears = _useState14[0],
      setShowCompareYears = _useState14[1];

  var _useState15 = useState(["2024"]),
      _useState16 = _slicedToArray(_useState15, 2),
      years = _useState16[0],
      setYears = _useState16[1];

  useEffect(function () {
    if (billingCentral) {
      getFilteredInvoices(Object.keys(categories).filter(function (cat) {
        return categories[cat];
      }), Object.keys(statuses).filter(function (status) {
        return statuses[status];
      }), dates).then(function (response) {
        // console.log("cojo valor de aqui", response.data);
        setFilteredInvoices(_toConsumableArray(response.data.invoices));
        setfilteredDashboard(_objectSpread({}, response.data.dashboard));
      })["catch"](function (err) {
        setFilteredInvoices(_toConsumableArray(invoices));
        setfilteredDashboard(_objectSpread({}, dashboard));
      });
    }
  }, [categories, dates, statuses, dashboard]);
  useEffect(function () {
    if (!billingCentral) {
      getFilteredInvoices(Object.keys(categories).filter(function (cat) {
        return categories[cat];
      }), Object.keys(statuses).filter(function (status) {
        return statuses[status];
      }), dates).then(function (response) {
        // console.log(response.data);
        setFilteredInvoices(_toConsumableArray(response.data.invoices));
        setfilteredDashboard(_objectSpread({}, response.data.dashboard));
      })["catch"](function (err) {
        setFilteredInvoices(_toConsumableArray(invoices));
        setfilteredDashboard(_objectSpread({}, dashboard));
      });
    }
  }, [categories, dates, statuses]);
  useEffect(function () {
    getFilteredInvoices([], [], {
      from: moment("".concat(year, "/01/01")).toDate(),
      to: moment("".concat(year, "/12/31")).toDate()
    }).then(function (response) {
      // console.log(year);
      // console.log("response change year", response);
      setFilteredInvoices(_toConsumableArray(response.data.invoices));
      setfilteredDashboard(_objectSpread({}, response.data.dashboard));
      setDates({
        from: null,
        to: null
      });
      setCategories(categoriesState);
      setStatuses(statusesState);
    })["catch"](function (err) {
      setFilteredInvoices(_toConsumableArray(invoices));
      setfilteredDashboard(_objectSpread({}, dashboard));
      setDates({
        from: null,
        to: null
      });
      setCategories(categoriesState);
      setStatuses(statusesState);
    });
  }, [year]);

  var handleChange = function handleChange(name, type) {
    return function (event) {
      if (type === "category") {
        setCategories(_objectSpread(_objectSpread({}, categories), {}, _defineProperty({}, name, event.target.checked)));
      } else if (type === "status") {
        setStatuses(_objectSpread(_objectSpread({}, statuses), {}, _defineProperty({}, name, event.target.checked)));
      } else if (type === "date") {
        var momentDate = moment(event).toDate();

        if (name === "from") {
          momentDate.setHours(0, 0, 0, 0);
        } else if (name === "to") {
          momentDate.setHours(23, 59, 59, 59);
        }

        setDates(_objectSpread(_objectSpread({}, dates), {}, _defineProperty({}, name, momentDate)));
      }
    };
  };

  var handleShowFilters = function handleShowFilters() {
    setShowFilters(!showFilters);
  };

  var handleShowCompareYears = function handleShowCompareYears() {
    setShowCompareYears(!showCompareYears);
    setShowFilters(false);
  };

  var handleChangeYears = function handleChangeYears(e) {
    setYears(e.target.value);
    handleSelectYears(e.target.value);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, !showCompareYears && /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    "data-cy": "view-columns",
    onClick: handleShowFilters
  }, /*#__PURE__*/React.createElement(FilterListIcon, {
    fontSize: "default",
    color: showFilters ? "primary" : "inherit"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: showCompareYears ? "contained" : "outlined",
    onClick: handleShowCompareYears
  }, translation ? translation.compare : "Compare"), showCompareYears && /*#__PURE__*/React.createElement(Select, {
    multiple: true,
    value: years,
    onChange: handleChangeYears
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "2020"
  }, "2020"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2021"
  }, "2021"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2022"
  }, "2022"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2023"
  }, "2023"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "2024"
  }, "2024"))), showFilters && /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 6,
    lg: 8,
    className: classes.layout
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      width: "100%"
    }
  }, translation ? translation.filterByCategory : "Category"), /*#__PURE__*/React.createElement("div", {
    className: [classes.flex, classes.wrap].join(" ")
  }, categories && Object.keys(categories).map(function (category) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: categories[category],
        onChange: handleChange(category, "category"),
        value: category,
        color: "primary"
      }),
      style: {
        marginLeft: 0
      },
      label: category.replace("_", " ").toUpperCase()
    });
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    style: {
      width: "100%"
    }
  }, translation ? translation.filterByStatus : "Status"), /*#__PURE__*/React.createElement("div", {
    className: [classes.flex, classes.wrap].join(" ")
  }, statuses && Object.keys(statuses).map(function (status) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      control: /*#__PURE__*/React.createElement(Checkbox, {
        checked: statuses[status],
        onChange: handleChange(status, "status"),
        value: status,
        color: "primary"
      }),
      style: {
        marginLeft: 0
      },
      label: status.replace("_", " ").toUpperCase()
    });
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6,
    md: 6,
    lg: 4,
    className: classes.layout
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translation ? translation.filterByDate : "Date"), /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(MuiPickersUtilsProvider, {
    utils: MomentUtils,
    locale: "es"
  }, /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    label: "From",
    disableToolbar: true,
    autoOk: true,
    name: "from",
    variant: "inline",
    format: "DD/MM/YYYY",
    value: dates.from || null,
    onChange: handleChange("from", "date"),
    style: {
      marginRight: "5%"
    }
  }), /*#__PURE__*/React.createElement(KeyboardDatePicker, {
    disableToolbar: true,
    autoOk: true,
    label: "To",
    name: "to",
    variant: "inline",
    format: "DD/MM/YYYY",
    value: dates.to || null,
    onChange: handleChange("to", "date"),
    style: {
      marginRight: "5%"
    }
  }))))), /*#__PURE__*/React.createElement(Grid, {
    xs: 12,
    md: 12,
    lg: 12
  }, /*#__PURE__*/React.createElement(InvoicesData, {
    dashboard: _objectSpread(_objectSpread({}, filteredDashboard), totals),
    translation: translation ? translation : null,
    franchise: franchise,
    groupedByCategory: groupedByCategory,
    data: showCompareYears ? compareInvoices : filteredInvoices,
    locale: locale,
    compareYears: showCompareYears,
    years: years
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    lg: 12
  }, centralUser && filteredInvoices || franchise && invoices ? /*#__PURE__*/React.createElement(DataTable, {
    key: "_invoices",
    data: filteredInvoices,
    columns: columns,
    title: translation ? null : "Invoices",
    translation: translation ? translation.datatable.invoices : null,
    options: _objectSpread(_objectSpread({}, options), {}, {
      filter: false
    })
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    count: 1,
    height: 40
  })));
};

export { FilterInvoicesList };